import { decodeRawRentalCarOfficeFromAPI } from '^/api2/getRentalCarOfficeLocationsByCity/GetCategoriesByCity.convert';
import { LocationNameType, RentalCarOfficeId } from '^/types/__BrandedLocationTypes';

export const OKINAWA_NAHA_AIRPORT_LOCATION_ID = '7903562';
export const OKINAWA_MIEBASHI_STATION_LOCATION_ID = '7903563';

type RentalOffice = ReturnType<typeof decodeRawRentalCarOfficeFromAPI> | null | undefined;

/**
 * MRT 영업소 표기명을 반환하며, 오키나와 특정 ID는 고정된 한글명을 사용합니다.
 */
export function getMrtOfficeDisplayName(
  office: RentalOffice,
): LocationNameType | undefined;
export function getMrtOfficeDisplayName(
  locationId: RentalCarOfficeId | null | undefined,
  fallback?: LocationNameType,
): LocationNameType | undefined;
export function getMrtOfficeDisplayName(
  officeOrLocationId: RentalOffice | RentalCarOfficeId | null | undefined,
  fallback?: LocationNameType,
): LocationNameType | undefined {
  const locationId =
    typeof officeOrLocationId === 'string'
      ? officeOrLocationId
      : officeOrLocationId?.location_id;
  if (locationId === OKINAWA_NAHA_AIRPORT_LOCATION_ID) {
    return '나하 공항' as LocationNameType;
  }
  if (locationId === OKINAWA_MIEBASHI_STATION_LOCATION_ID) {
    return '국제 거리' as LocationNameType;
  }
  if (typeof officeOrLocationId === 'string') {
    return fallback;
  }
  return officeOrLocationId?.locationDescriptions.get('ko')?.description;
}
